"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DatabaseDiff = exports.EntityDiff = exports.zDiff = void 0;
exports.databaseDiff = databaseDiff;
exports.databaseEvolve = databaseEvolve;
const zod_1 = require("zod");
const utils_1 = require("@azimutt/utils");
const database_1 = require("./database");
const databaseUtils_1 = require("./databaseUtils");
// FIXME: Work In Progress, make it more specific
const zDiff = (schema) => zod_1.z.object({
    left: schema.array().optional(),
    right: schema.array().optional(),
    both: zod_1.z.object({ left: schema, right: schema }).array().optional()
}).strict();
exports.zDiff = zDiff;
exports.EntityDiff = zod_1.z.object({
    left: database_1.Entity,
    right: database_1.Entity,
    attrs: (0, exports.zDiff)(database_1.Attribute).optional(),
    indexes: (0, exports.zDiff)(database_1.Index).optional(),
}).describe('EntityDiff');
exports.DatabaseDiff = zod_1.z.object({
    entities: zod_1.z.object({ left: database_1.Entity.array().optional(), right: database_1.Entity.array().optional(), both: exports.EntityDiff.array().optional() }).optional(),
    relations: (0, exports.zDiff)(database_1.Relation).optional(),
    types: (0, exports.zDiff)(database_1.Type).optional(),
}).strict().describe('DatabaseDiff');
function databaseDiff(leftDb, rightDb) {
    const { left: leftEntities, right: rightEntities, both: commonEntities } = (0, utils_1.diffBy)(leftDb.entities || [], rightDb.entities || [], databaseUtils_1.entityToId);
    const updatedEntities = commonEntities?.map(entity => {
        return (0, utils_1.removeEmpty)({
            ...entity,
            attrs: defaultDiff(entity.left.attrs?.map(cleanStats) || [], entity.right.attrs?.map(cleanStats) || [], a => a.name),
            indexes: defaultDiff(entity.left.indexes?.map(cleanStats) || [], entity.right.indexes?.map(cleanStats) || [], indexToId)
        });
    }).filter(d => d.attrs || d.indexes);
    return (0, utils_1.removeEmpty)({
        entities: (0, utils_1.removeEmpty)({
            left: leftEntities,
            right: rightEntities,
            both: updatedEntities
        }),
        relations: defaultDiff(leftDb.relations || [], rightDb.relations || [], databaseUtils_1.relationToId),
        types: defaultDiff(leftDb.types || [], rightDb.types || [], databaseUtils_1.typeToId)
    });
}
function defaultDiff(leftArr, rightArr, getKey) {
    const { left, right, both } = (0, utils_1.diffBy)(leftArr, rightArr, getKey);
    return (0, utils_1.removeEmpty)({
        left,
        right,
        both: both?.filter(({ left, right }) => !(0, utils_1.equalDeep)(left, right))
    });
}
// TODO
function databaseEvolve(db, diff) {
    return db;
}
const indexToId = (i) => `${i.name}(${i.attrs.map(databaseUtils_1.attributePathToId).join(', ')})`;
const cleanStats = (obj) => (0, utils_1.removeFieldsDeep)(obj, ['stats']);
//# sourceMappingURL=databaseDiff.js.map